import styled, { css } from 'styled-components'
import { breakpoint } from 'utils'

import { ReactComponent as PencilIcon } from 'icons/pencil-16.svg'

export const Description = styled.p`
  margin: 0;

  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.4;

  color: ${({ theme }) => theme.colors.foreground.secondary[4]};
`

const headerStyle = css`
  padding: 0 4px;
  margin: 0 -4px;

  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1.3;

  word-break: break-all;
  hyphens: none;

  color: ${({ theme }) => theme.colors.foreground.secondary[1]};

  + ${Description} {
    margin-top: 4px;
  }
`

export const Pencil = styled(PencilIcon)`
  margin-left: 8px;
  width: 16px;

  transition: opacity ${({ theme }) => theme.transitions.duration[1]};

  /* This color should be "Light/colors.foreground.secondary.4" but given the icon composition */
  /* Opacity needs to be applied to the whole object */
  color: ${({ theme }) => theme.colors.foreground.secondary[1]};
  opacity: 0.55;
`

export const Header = styled.h1`
  ${headerStyle}
  overflow: hidden;

  display: inline-block;
  outline: none;

  > ${Pencil} {
    opacity: 0;
  }

  :focus {
    border-radius: ${({ theme }) => theme.radii.large};
    box-shadow: 0 0 0 2px ${({ theme }) => theme.colors.primaryTint[35]};
  }

  :hover,
  :focus {
    > ${Pencil} {
      opacity: 0.55;
    }
  }
`

export const Wrapper = styled.div`
  margin-bottom: 16px;
  max-width: 540px;
  position: relative;

  ${breakpoint('sm')`
      margin-bottom: 40px;
  `}
`

export const EditInput = styled.textarea`
  ${headerStyle}
  box-sizing: content-box;

  position: absolute;
  top: 0;
  left: 0;

  width: 100%;
  height: 100%;
  min-height: 1.3em;

  border: none;
  background: none;

  outline: none;
  resize: none;

  ::selection {
    background: ${({ theme }) => theme.colors.primaryTint[35]};
  }

  ::placeholder {
    color: ${({ theme }) => theme.colors.state.disabled};
  }
`

export const Form = styled.form`
  margin: 0;
`

export const PreviewHeader = styled(Header)`
  width: 100%;
  min-height: 1.3em;

  box-sizing: content-box;
  visibility: hidden;
`
